import React, { createContext, useState, useEffect } from 'react';
import { auth } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [userRole, setUserRole] = useState('simple'); // simple, pro, admin
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                try {
                    // Fetch user role from Firestore
                    const userDocRef = doc(db, 'profiles', user.uid);
                    const userDocSnap = await getDoc(userDocRef);
                    
                    if (userDocSnap.exists()) {
                        const userData = userDocSnap.data();
                        const role = userData.role || 'simple';
                        
                        // console.log('Auth Context User Role:', {
                        //     uid: user.uid,
                        //     role: role,
                        //     userData: userData
                        // });
                        
                        setCurrentUser(user);
                        setUserRole(role);
                    } else {
                        // Fallback if no user document found
                        setCurrentUser(user);
                        setUserRole('simple');
                    }
                } catch (error) {
                    console.error('Error fetching user role:', error);
                    setCurrentUser(user);
                    setUserRole('simple');
                }
            } else {
                setCurrentUser(null);
                setUserRole('simple');
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const value = {
        currentUser,
        userRole,
        setUserRole,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};
